export default __webpack_public_path__ + "static/media/darkAvatar.195285b9.svg";